<div class="flex h-screen overflow-hidden bg-slate100 text-slate900 dark:bg-slate900 dark:text-white">
  <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">

    <app-portal-topbar (menuToggle)="toggleMobileSidebar()"></app-portal-topbar>

    <div class="relative flex min-h-0 flex-1 overflow-hidden">
      @if (mobileSidebarOpen()) {
        <div
          class="absolute inset-0 z-40 bg-black/40 lg:hidden"
          (click)="closeMobileSidebar()"
        ></div>
      }

      <app-portal-sidebar
        class="absolute inset-y-0 left-0 z-50 h-full shrink-0 -translate-x-full transition-transform duration-300 ease-in-out lg:static lg:translate-x-0"
        [class.translate-x-0]="mobileSidebarOpen()"
        [collapsed]="sidebarCollapsed()"
        [mobileOpen]="mobileSidebarOpen()"
        (toggleCollapse)="toggleSidebar()"
        (navigate)="closeMobileSidebar()"
      ></app-portal-sidebar>

      <div class="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <main class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-6 sm:px-7">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>

  </div>
</div>
